import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
//reducers
import { loginReducer } from "./reducers/loginReducer";
import { vehicleTypesReducer } from "./reducers/vehicleTypeReducer";
import { deliverySlotsReducer } from "./reducers/deliverySlotsReducer";
import { bookingReducer } from "./reducers/bookingReducer";
import { userProfile } from "./reducers/userProfileReducer";
import { myTrips } from "./reducers/myTripReducer";
import { paymentMethodReducer } from "./reducers/paymentMethodsReducer";
import { companyReducer } from "./reducers/companyReducer";

//combining the reducers
const reducer = combineReducers({
  loginReducer,
  vehicleTypesReducer,
  deliverySlotsReducer,
  bookingReducer,
  userProfile,
  myTrips,
  paymentMethodReducer,
  companyReducer,
});

const initialState = {};
// added the thunk middleware
const middleware = [thunk];

const composeEnhancers =
  process.env.NODE_ENV === "development"
    ? require("redux-devtools-extension").composeWithDevTools
    : compose;

// created the redux store
const Store = createStore(
  reducer,
  initialState,
  composeEnhancers(applyMiddleware(...middleware)),
);

export default Store;
